module.exports = __webpack_public_path__ + "img/IMG_5905.6940ea0f.jpg";